import { createFileRoute, Navigate } from '@tanstack/react-router';

import { ChatInterface } from './-components/chat-interface';

import { z } from 'zod';

import { useAuthContext } from '@web/auth';
import { hasPermission } from '@shared/auth';

export const Route = createFileRoute('/dashboard/chat/')({
  validateSearch: z.object({
    id: z.string().optional(),
    name: z.string().optional(),
  }),

  component: View,
});

function View() {
  const { user } = useAuthContext();

  if (!user) return null;

  if (!hasPermission(user, 'communication_module', 'access')) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <div className="container absolute inset-0 p-0 py-2 sm:py-4 md:py-10">
      <ChatInterface />
    </div>
  );
}
